import(/* webpackMode: "eager" */ "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/apps/search/src/assets/svg/for-rent-last-7-days.svg");
;
import(/* webpackMode: "eager" */ "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/apps/search/src/assets/svg/for-sale-for-flipping.svg");
;
import(/* webpackMode: "eager" */ "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/apps/search/src/assets/svg/for-sale-per-caprate.svg");
;
import(/* webpackMode: "eager" */ "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/apps/search/src/assets/svg/for-sale-to-live.svg");
;
import(/* webpackMode: "eager" */ "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/apps/search/src/modules/results/Results.tsx");
